/**
   Update variant change color tip name
  implemented:layout/theme.liquid,
**/

 document.addEventListener("DOMContentLoaded", function () {

   const tip_el = document.querySelector("[data-js-tip-variant]")
    if(!tip_el){
     return console.log("Cant find color tip DOM element for tip color on change")
   }

   // Choose tip Hover
   tip_el.addEventListener('mouseenter', (e)=>{
      const sku_el = document.querySelector("[data-js-product-sku] span")
       if(!sku_el){
         return console.log("Cant find SKU DOM element for tip color on change")
       }
       //alert(sku_el.innerText)
       const tip_color = getSKUColor(sku_el.innerText)

       // option #1
       setTimeout(()=>{
         const tippy_perent = document.querySelector('.tippy-popper')
         const tippy = document.querySelector('.tippy-content')
          if(!tippy){
            return console.log("Cant find tippy DOM element for tip color on change")
          }
          tippy.innerText = `${tip_color} Tip + $0.00`
         tippy_perent.style.display = "block"
       },0)
    
   })
   
  // Choose tip text
   const sku_el = document.querySelector("[data-js-product-sku] span")
   if(!sku_el){
     return console.log("Cant find SKU DOM element for tip color on change")
   }
   //console.log(sku_el.innerText)

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };
    
    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
            const selected_sku = mutation.target.innerHTML
            if(selected_sku === ''){
               return console.log("Cant find Mutation SKU DOM element for tip color on change")
            }
            //console.log(mutation.target)

            const is_color_tip = document.querySelector("[data-js-color-tip]")
            if(is_color_tip.classList.contains('active')){
              const tip_color = getSKUColor(selected_sku)
              
              const choose_tip = document.querySelector('[data-option-name="choose-tip"] [data-label-value]')
              if(!choose_tip){
                return console.log("Cant find tippy DOM element for tip color on change")
              }
              choose_tip.innerText = `${tip_color} + $0.00`
            }
          
        } 
      }
    };
    
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    
    // Start observing the target node for configured mutations
    observer.observe(sku_el, config);

   function getSKUColor(sku = ""){
      const splitted_sku = sku.split('*')
       if(splitted_sku.length === 0){
          console.log("Cant find SKU splitted element for tip color on change")
          return 'Black'
       }
    
       if(splitted_sku.includes('blue')){
         console.log("tip is blue")
         return 'Blue' 
       }else if(splitted_sku.includes('orange')){
          console.log("tip is orange")
          return 'Orange'
       }else if(splitted_sku.includes('pink')){
          console.log("tip is pink")
          return 'Pink'
       }else if(splitted_sku.includes('purple')){
          console.log("tip is purple")
          return 'Purple'
       }else{
         return 'Black'
       }
   }


 })